import React from 'react'
import PropTypes from 'prop-types'
import Summary from '../Summary'
import RentVehicleExtraInfo from './RentVehicleExtraInfo'
import NeededDocs from './NeededDocs'
import ContractExtraInfo from './ContractExtraInfo'
import ExtraInfoBlock from './ExtraInfoBlock'
import { Box, HorizontalRule } from '@elparking/components'
import { bookingConfirmPageName } from 'commons/js/services/analytics/TealiumEventsCollection/rentalCar'
import InfoAgeRequirements from './InfoAgeRequirements'

const DetailsBlock = ({
    booking,
    showModal,
    cancelBlock,
    editBlock,
    token,
}) => {
    return <Box>
        <Summary
          id={booking.id}
          cancelled={booking.cancelled}
          supplierReference={booking.supplierReference}
          startRent={{ date: booking.startDate, place: booking.originPOI }}
          endRent={{ date: booking.endDate, place: booking.destinationPOI }}
          seller={booking.seller}
          car={booking.car}
          features={booking.insuranceConfigs}
          token={token}
          onCancel={showModal}
          cancelBlock={cancelBlock}
          editBlock={editBlock}
          isFinished={booking.finished}
          isCancelable={booking.isCancelable}
          timeZone={booking.timeZone}
          pageName={bookingConfirmPageName}/>
        <Box display={['block', 'block', 'none']}>
            {!booking.cancelled && <ExtraInfoBlock booking={booking} onDownloadApp={showModal}/>}
        </Box>
        {!booking.cancelled && <>
            <RentVehicleExtraInfo
              urlCheckIn={booking.urlCheckIn}
              originPOI={booking.originPOI}
              destinationPOI={booking.destinationPOI}/>
            <HorizontalRule/>
            <NeededDocs companyName={booking.seller.name} onSendDocs={showModal} idSupplier={booking.seller.id} />
            <InfoAgeRequirements mb='1em' />
            <HorizontalRule/>
            <ContractExtraInfo items={booking.footerConfig} />
        </>}
    </Box>
}
DetailsBlock.propTypes = {
    booking: PropTypes.object,
    showModal: PropTypes.func,
    cancelBlock: PropTypes.node,
    editBlock: PropTypes.node,
    token: PropTypes.string,
}

DetailsBlock.defaultProps = {
    booking: {},
    showModal: () => {},
}
export default DetailsBlock
